import { useNavigation } from '@/hooks/useNavigation'

import { DeviceType, IncidentType } from '@/graphql/generated/schemas'
import { useAppDispatch } from '@/redux/hooks'
import {
  closeIncidentDrawer,
  openDeviceDrawer,
  setDevice,
} from '@/redux/ui/uiSlice'
import { isDeviceDrawerSupported } from '@/utils/devices'

import { getDescriptionMessage } from '../utils/feedUtils'

interface UseIncidentDescriptionIProps {
  deviceId?: string
  deviceType?: DeviceType
  floorId?: string
  type?: IncidentType | null
}

export const useIncidentDescription = ({
  deviceId,
  deviceType,
  floorId,
  type,
}: UseIncidentDescriptionIProps) => {
  const dispatch = useAppDispatch()
  const { goToFloorPlan } = useNavigation()

  // Undefined for types DeviceDrawer can't render (Alarm, Checkpoint).
  // Consumers pass this straight to `onClick`, so the chip renders
  // non-interactive instead of dead-clicking into a stuck-open drawer.
  const onDeviceClick = isDeviceDrawerSupported(deviceType)
    ? () => {
        dispatch(setDevice({ id: deviceId, type: deviceType }))
        dispatch(openDeviceDrawer())
      }
    : undefined

  const onFloorClick = () => {
    dispatch(closeIncidentDrawer())
    goToFloorPlan(floorId)
  }
  const message = getDescriptionMessage(type)

  return {
    message,
    onDeviceClick,
    onFloorClick,
  }
}
